const commands = [
    {command: 'bold', label: 'B', title: 'Bold'},
    {command: 'italic', label: 'I', title: 'Italic'},
    {
        command: 'blockquote',
        title: 'Blockquote',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 216zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-136z"/></svg>'
    },
    {
        command: 'insertUnorderedList',
        title: 'Unordered list',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M32 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L152 64zm0 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-336 0zm0 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-336 0zM64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"/></svg>'
    },
    {
        command: 'insertOrderedList',
        title: 'Ordered list',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 64c0 8.8 7.2 16 16 16l40 0 0 112-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-128c0-8.8-7.2-16-16-16L16 48C7.2 48 0 55.2 0 64zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM77 288c-11.6 0-23 3.4-32.7 9.9L7.1 322.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L62 324.5c4.4-3 9.6-4.5 15-4.5l1.9 0c13.8 0 25.1 11.2 25.1 25.1 0 8.7-4.5 16.8-11.9 21.3l-79.6 49C4.7 420.1 0 428.6 0 437.7 0 452.2 11.8 464 26.3 464L128 464c8.8 0 16-7.2 16-16s-7.2-16-16-16l-81.5 0 62.3-38.3c16.9-10.4 27.2-28.8 27.2-48.6 0-31.5-25.5-57.1-57.1-57.1L77 288z"/></svg>'
    },
    {
        command: 'createLink',
        title: 'Link',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-17.9 3.2-35.5 9.4-51.9 4.6-12.4 18.5-18.7 30.9-14.1S259 220 254.4 232.4c-4.2 11.1-6.4 23-6.4 35.2 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 17.9-3.2 35.5-9.4 51.9-4.6 12.4-18.5 18.7-30.9 14.1S317 292 321.6 279.6c4.2-11.1 6.4-23 6.4-35.1 0-55.5-45-100.5-100.5-100.5z"/></svg>'
    },
    {
        command: 'undo',
        title: 'Undo',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 64c-56.8 0-107.9 24.7-143.1 64l47.1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 192c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 54.7C110.9 33.6 179.5 0 256 0 397.4 0 512 114.6 512 256S397.4 512 256 512c-87 0-163.9-43.4-210.1-109.7-10.1-14.5-6.6-34.4 7.9-44.6s34.4-6.6 44.6 7.9c34.8 49.8 92.4 82.3 157.6 82.3 106 0 192-86 192-192S362 64 256 64z"/></svg>'
    }
];

const editIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="17" height="17" aria-hidden="true" focusable="false"><path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"/></svg>';

function syncTextarea(editor, textarea) {
    textarea.value = serializeEditorHtml(editor);
}

function trimTrailingTextWhitespace(node) {
    while (node.lastChild) {
        const child = node.lastChild;

        if (child.nodeType === Node.TEXT_NODE) {
            child.nodeValue = child.nodeValue.replace(/[\s\u00a0]+$/u, '');
            if (child.nodeValue === '') {
                child.remove();
                continue;
            }
        }

        break;
    }
}

function isEmptyHtmlElement(element) {
    if (!element || !['P', 'DIV'].includes(element.tagName)) {
        return false;
    }

    const html = element.innerHTML
        .replace(/<br\s*\/?>/gi, '')
        .replace(/&nbsp;/gi, '')
        .trim();

    return element.textContent.trim() === '' && html === '';
}

function serializeEditorHtml(editor) {
    const clone = editor.cloneNode(true);

    trimTrailingTextWhitespace(clone);

    while (clone.lastElementChild && isEmptyHtmlElement(clone.lastElementChild)) {
        clone.lastElementChild.remove();
        trimTrailingTextWhitespace(clone);
    }

    return clone.innerHTML.trim();
}

function closestLink(node, editor) {
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    const link = element?.closest?.('a');
    return link && editor.contains(link) ? link : null;
}

function getSelectedLink(editor) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        return null;
    }

    return closestLink(selection.anchorNode, editor) || closestLink(selection.focusNode, editor);
}

function closestElement(node, editor, selector) {
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    const match = element?.closest?.(selector);
    return match && editor.contains(match) ? match : null;
}

function getSelectionNode() {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        return null;
    }

    return selection.anchorNode;
}

function getCurrentBlock(editor) {
    const node = getSelectionNode();
    return closestElement(node, editor, 'p, div, li, blockquote');
}

function isEmptyEditableBlock(block) {
    if (!block) {
        return false;
    }

    return block.textContent.trim() === '' && !block.querySelector('img, iframe, video');
}

function setSelectionToNode(node) {
    const range = document.createRange();
    range.selectNodeContents(node);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
}

function unwrapLink(link) {
    const fragment = document.createDocumentFragment();
    while (link.firstChild) {
        fragment.appendChild(link.firstChild);
    }

    link.replaceWith(fragment);
}

function applyLinkAttributes(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
}

function runCommand(command, editor, textarea) {
    editor.focus();

    if (command === 'blockquote') {
        const currentBlock = String(document.queryCommandValue('formatBlock') || '').toLowerCase();
        document.execCommand('formatBlock', false, currentBlock === 'blockquote' ? 'p' : 'blockquote');
        syncTextarea(editor, textarea);
        return;
    }

    if (command === 'createLink') {
        const selectedLink = getSelectedLink(editor);
        const href = window.prompt('Enter link URL', selectedLink?.getAttribute('href') || '');
        if (href === null) {
            return;
        }

        if (selectedLink) {
            if (href.trim() === '') {
                unwrapLink(selectedLink);
            } else {
                selectedLink.setAttribute('href', href.trim());
                applyLinkAttributes(selectedLink);
                setSelectionToNode(selectedLink);
            }
        } else {
            if (href.trim() === '') {
                return;
            }

            document.execCommand('createLink', false, href.trim());
            const newLink = getSelectedLink(editor);
            if (newLink) {
                applyLinkAttributes(newLink);
            }
        }

        syncTextarea(editor, textarea);
        return;
    }

    document.execCommand(command, false, null);
    syncTextarea(editor, textarea);
}

function placeCaretAtStart(node) {
    const range = document.createRange();
    range.selectNodeContents(node);
    range.collapse(true);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
}

function removeTrailingWhitespace(node) {
    while (node.lastChild && node.lastChild.nodeType === Node.TEXT_NODE && node.lastChild.nodeValue.trim() === '') {
        node.lastChild.remove();
    }
}

function trimBlockquoteEnd(blockquote, currentBlock) {
    if (currentBlock && currentBlock !== blockquote && isEmptyEditableBlock(currentBlock)) {
        currentBlock.remove();
    }

    removeTrailingWhitespace(blockquote);

    while (blockquote.lastElementChild && isEmptyHtmlElement(blockquote.lastElementChild)) {
        blockquote.lastElementChild.remove();
        removeTrailingWhitespace(blockquote);
    }

    while (blockquote.lastChild && blockquote.lastChild.nodeName === 'BR') {
        blockquote.lastChild.remove();
        removeTrailingWhitespace(blockquote);
    }
}

function exitBlockquote(editor, textarea, force = false) {
    const node = getSelectionNode();
    const blockquote = closestElement(node, editor, 'blockquote');
    const currentBlock = getCurrentBlock(editor);

    if (!blockquote || (!force && !isEmptyEditableBlock(currentBlock))) {
        return false;
    }

    trimBlockquoteEnd(blockquote, currentBlock);

    const paragraph = document.createElement('p');
    paragraph.appendChild(document.createElement('br'));
    blockquote.insertAdjacentElement('afterend', paragraph);

    if (blockquote.textContent.trim() === '' && !blockquote.querySelector('img, iframe, video')) {
        blockquote.remove();
    }

    placeCaretAtStart(paragraph);
    syncTextarea(editor, textarea);
    delete editor.dataset.blockquoteExitPending;

    return true;
}

function handleEditorKeydown(event, editor, textarea) {
    if ((event.ctrlKey || event.metaKey) && !event.altKey) {
        const key = event.key.toLowerCase();

        if (key === 'b' || key === 'i') {
            event.preventDefault();
            runCommand(key === 'b' ? 'bold' : 'italic', editor, textarea);
            return;
        }
    }

    if (event.key === 'Enter') {
        const blockquote = closestElement(getSelectionNode(), editor, 'blockquote');
        if (!blockquote) {
            delete editor.dataset.blockquoteExitPending;
            return;
        }

        if (
            editor.dataset.blockquoteExitPending === 'true'
            || isEmptyEditableBlock(getCurrentBlock(editor))
        ) {
            event.preventDefault();
            exitBlockquote(editor, textarea, true);
            return;
        }

        editor.dataset.blockquoteExitPending = 'true';
        return;
    }

    delete editor.dataset.blockquoteExitPending;
}

function createButton(item, editor, textarea) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `forum-rich-text__button forum-rich-text__button--${item.command.toLowerCase()}`;
    if (item.icon) {
        button.innerHTML = item.icon;
        button.querySelector('svg')?.setAttribute('aria-hidden', 'true');
        button.querySelector('svg')?.setAttribute('focusable', 'false');
    } else {
        button.textContent = item.label;
    }
    button.title = item.title;
    button.setAttribute('aria-label', item.title);
    button.addEventListener('click', () => runCommand(item.command, editor, textarea));
    return button;
}

function enhanceTextarea(textarea) {
    if (textarea.dataset.richTextReady === 'true') {
        return;
    }

    textarea.dataset.richTextReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'forum-rich-text';

    const toolbar = document.createElement('div');
    toolbar.className = 'forum-rich-text__toolbar';
    toolbar.setAttribute('role', 'toolbar');
    toolbar.setAttribute('aria-label', 'Message formatting');

    const editor = document.createElement('div');
    editor.className = 'forum-rich-text__editor';
    editor.contentEditable = 'true';
    editor.setAttribute('role', 'textbox');
    editor.setAttribute('aria-multiline', 'true');
    editor.setAttribute('aria-label', textarea.labels?.[0]?.textContent || textarea.name);
    editor.innerHTML = textarea.value;

    commands.forEach((item) => {
        toolbar.appendChild(createButton(item, editor, textarea));
    });

    wrapper.appendChild(toolbar);
    wrapper.appendChild(editor);
    textarea.parentNode.insertBefore(wrapper, textarea);
    textarea.classList.add('forum-rich-text__source');

    editor.addEventListener('input', () => syncTextarea(editor, textarea));
    editor.addEventListener('blur', () => syncTextarea(editor, textarea));
    editor.addEventListener('keydown', (event) => handleEditorKeydown(event, editor, textarea));
    editor.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
            event.preventDefault();
        }
    });
    textarea.form?.addEventListener('submit', () => syncTextarea(editor, textarea));
}

function createInlineEditForm(post, content) {
    const form = document.createElement('form');
    form.className = 'forum-post-edit forum-form';

    const textarea = document.createElement('textarea');
    textarea.name = 'Content';
    textarea.className = 'js-forum-rich-text';
    textarea.value = content.innerHTML.trim();

    const actions = document.createElement('div');
    actions.className = 'forum-post-edit__actions';

    const save = document.createElement('button');
    save.type = 'submit';
    save.className = 'button forum-post-edit__save';
    save.textContent = 'Save';

    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'button forum-post-edit__cancel';
    cancel.textContent = 'Cancel';

    const status = document.createElement('p');
    status.className = 'forum-post-edit__status';
    status.setAttribute('aria-live', 'polite');

    actions.append(save, cancel);
    form.append(textarea, actions, status);

    cancel.addEventListener('click', () => closeInlineEditor(post));
    form.addEventListener('submit', (event) => saveInlineEdit(event, post, form, content, status));

    return form;
}

function closeInlineEditor(post) {
    const content = post.querySelector('.forum-post__content');
    const form = post.querySelector('.forum-post-edit');

    form?.remove();
    if (content) {
        content.hidden = false;
    }

    post.classList.remove('forum-post--editing');
}

async function saveInlineEdit(event, post, form, content, status) {
    event.preventDefault();

    const textarea = form.querySelector('textarea[name="Content"]');
    const submit = form.querySelector('button[type="submit"]');
    const data = new FormData(form);
    data.set('Content', textarea.value);
    data.set('SecurityID', post.dataset.securityId || '');

    status.textContent = '';
    submit.disabled = true;

    try {
        const response = await window.fetch(post.dataset.editUrl, {
            method: 'POST',
            body: data,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        const payload = await response.json();

        if (!response.ok) {
            throw new Error(payload.error || 'Could not save changes.');
        }

        content.innerHTML = payload.content || '';
        closeInlineEditor(post);
    } catch (error) {
        status.textContent = error.message || 'Could not save changes.';
    } finally {
        submit.disabled = false;
    }
}

function openInlineEditor(post) {
    if (post.classList.contains('forum-post--editing')) {
        return;
    }

    const content = post.querySelector('.forum-post__content');
    if (!content || !post.dataset.editUrl) {
        return;
    }

    const form = createInlineEditForm(post, content);
    content.hidden = true;
    content.insertAdjacentElement('afterend', form);
    post.classList.add('forum-post--editing');

    const textarea = form.querySelector('textarea');
    enhanceTextarea(textarea);

    const editor = form.querySelector('.forum-rich-text__editor');
    editor?.focus();
}

function setupInlinePostEditing() {
    document.querySelectorAll('[data-forum-edit-button]').forEach((button) => {
        if (button.dataset.inlineEditReady === 'true') {
            return;
        }

        button.dataset.inlineEditReady = 'true';
        button.innerHTML = editIcon;
        button.addEventListener('click', () => {
            const post = button.closest('[data-forum-post]');
            if (!post) {
                return;
            }

            if (post.classList.contains('forum-post--editing')) {
                closeInlineEditor(post);
            } else {
                openInlineEditor(post);
            }
        });
    });
}

export default function setupForumRichText() {
    document.querySelectorAll('textarea.js-forum-rich-text').forEach(enhanceTextarea);
    setupInlinePostEditing();
}
